var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInstagramNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23263_1999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.962 0H7.03795C3.15716 0 0 3.15716 0 7.03795V18.9622C0 22.8428 3.15716 26 7.03795 26H18.9622C22.8428 26 26 22.8428 26 18.9622V7.03795C26 3.15716 22.8428 0 18.962 0ZM24.4757 18.9622C24.4757 22.0023 22.0023 24.4757 18.962 24.4757H7.03795C3.99763 24.4757 1.52423 22.0023 1.52423 18.9622V7.03795C1.52423 3.99763 3.99763 1.52423 7.03795 1.52423H18.9622C22.0023 1.52423 24.4757 3.99763 24.4757 7.03795V18.9622Z",
    fill: "#00AAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 5.89062C9.07972 5.89062 5.89062 9.07972 5.89062 12.9998C5.89062 16.9199 9.07972 20.109 12.9998 20.109C16.9199 20.109 20.109 16.9199 20.109 12.9998C20.109 9.07972 16.9199 5.89062 12.9998 5.89062ZM12.9998 18.5847C9.92039 18.5847 7.41485 16.0794 7.41485 12.9998C7.41485 9.92039 9.92039 7.41485 12.9998 7.41485C16.0794 7.41485 18.5847 9.92039 18.5847 12.9998C18.5847 16.0794 16.0794 18.5847 12.9998 18.5847Z",
    fill: "#00AAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2794 3.36621C19.1209 3.36621 18.1787 4.30864 18.1787 5.46688C18.1787 6.62533 19.1209 7.56776 20.2794 7.56776C21.4378 7.56776 22.3803 6.62533 22.3803 5.46688C22.3803 4.30844 21.4378 3.36621 20.2794 3.36621ZM20.2794 6.04333C19.9616 6.04333 19.7029 5.78466 19.7029 5.46688C19.7029 5.14891 19.9616 4.89044 20.2794 4.89044C20.5974 4.89044 20.856 5.14891 20.856 5.46688C20.856 5.78466 20.5974 6.04333 20.2794 6.04333Z",
    fill: "#00AAE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23263_1999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagramNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram-nav.26ff2f92.svg";
export { ForwardRef as ReactComponent };